<template>
  <v-card class="celebration-card ma-1" elevation="0">
    <v-layout column fill-height>
      <v-layout column align-center>
        <div class="avatar-container">
          <div class="avatar-border" :style="{ backgroundImage: getBorderGradient(color) }">
            <v-img :src="image" class="avatar-image"></v-img>
          </div>
        </div>
        <v-card-title>
          <p class="title text-blue-v2">{{ title }}</p>
        </v-card-title>
        <div>
          <p class="subtitle">{{ subtitle }}</p> 
        </div>
      </v-layout>
      
      <v-spacer></v-spacer>
      
      <v-card-actions class="action-bottom">
        <v-btn flat :href="'mailto:' + email" class="btn-celebration mx-auto">
          <img class="icon-mail" width="16px" left color="#49494D" src="https://assets-intranet-security.s3.us-east-2.amazonaws.com/mail_outline.svg" alt="icon mail">
          <span style="border-bottom: 1px solid #49494D; line-height: 16px;">Enviar felicitaciones</span>
        </v-btn>
      </v-card-actions>
    </v-layout>
  </v-card>
</template>

<script>
export default {
  name: 'CelebrationCard',
  props: {
    image: String,
    title: String,
    subtitle: String,
    email: String,
    color: String
  },
  methods: {
    getBorderGradient(color) {
      switch(color) {
        case '#8D0C9A': // purpura
          return 'linear-gradient(to right, #6A2E92, #B683D8)';
        case '#008DCF': // lightblue
          return 'linear-gradient(to right, #018CCD, #67CEFE)';
        case '#FF052B': // red
          return 'linear-gradient(to right, #56ab2f, #a8e063)';
        case '#FF6E00': // orange
          return 'linear-gradient(to right, #EC7900, #FFC385)';
        case '#628D36': // green
          return 'linear-gradient(to right, #52912F, #A1D784)';
        default:
          return 'linear-gradient(to right, #9e9e9e, #9e9e9e)';
      }
    }
  }
};
</script>

<style scoped>
.celebration-card {
  display: flex;
  flex-direction: column;
  border-radius: 15px;
  text-align: center;
  height: 320px;
}

.avatar-container {
  position: relative;
  width: 100px; 
  height: 100px;
  min-height: 100px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.avatar-border {
  position: absolute;
  width: 100%;
  height: 100%;
  border-radius: 50%;
  padding: 4px;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: center;
}

.avatar-image {
  width: 100%;
  height: 100%;
  border-radius: 50%;
  object-fit: cover;
  z-index: 1;
}

.title {
  font-size: 1.375rem !important;
  font-family: "Titillium Web" !important;
  font-weight: 600;
  line-height: 36px !important;
  margin: 0;
}

.subtitle {
  font-size: 0.875rem;
  color: #919199;
  font-family: "Titillium Web" !important;
  margin: 0;
}

.v-card-actions {
  width: 100%;
  display: flex;
  justify-content: center;
  padding-bottom: 16px;
}

.action-bottom {
  margin-top: auto;
}

.btn-celebration {
  text-transform: capitalize;
  color: #49494D;
  font-weight: 600;
}
.icon-mail{
  margin-right: 8px;
}
</style>
